module.exports = __webpack_public_path__ + "static/media/wifi.2541c894.png";